import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPause,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import React, { Component } from "react";
import "./AudioPlayer.css";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../../../Util/contexts/AppContext";

export default class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioPlayerActive: false,
      audioVolume: 1,
      previousAudioVolume: 1,
      isAudioEnded: false,
      currentTime: 0,
      currentSliderPosition: 0,
      audioDuration: 0,
      audioFileFetchOutstanding: true,
    };
    this.audioFileRef = React.createRef();
    const audioFileURL = this.getAudioFileForAccent("American");
    this.audioFileRef.current = new Audio(audioFileURL);
    this.audioFileRef.current.oncanplay = () => {
      this.setState({
        audioFileFetchOutstanding: false,
        audioDuration: this.audioFileRef.current.duration,
      });
    };
  }

  static contextType = AppContext;

  getAudioFileForAccent = (selectedAccent) => {
    let accentProperty = this.getAudioForAccent();

    return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegment[accentProperty]}&Token=${this.props.userData.Token}`;
  };

  getAudioForAccent = () => {
    if (this.props.audioSegment.americanMp3) return "americanMp3";
    else if (this.props.audioSegment.britishMp3) return "britishMp3";
    else if (this.props.audioSegment.australianMp3) return "australianMp3";
    else if (this.props.audioSegment.irishMp3) return "irishMp3";
    else return null;
  };

  attachAudioListeners = () => {
    // Remove existing listeners first
    this.audioFileRef.current.removeEventListener("ended", this.handleAudioEnd);
    this.audioFileRef.current.removeEventListener("play", this.handleAudioPlay);
    this.audioFileRef.current.removeEventListener(
      "pause",
      this.handleAudioPause
    );

    this.audioFileRef.current.addEventListener("ended", this.handleAudioEnd);
    this.audioFileRef.current.addEventListener("play", this.handleAudioPlay);
    this.audioFileRef.current.addEventListener("pause", this.handleAudioPause);
  };

  handleAudioEnd = () => {
    this.setState({
      audioPlayerActive: false,
      isAudioEnded: true,
      currentSliderPosition: 100,
    });
    clearInterval(this.audioTimer);
  };

  handleAudioPlay = () => {
    this.setState({ audioPlayerActive: true });
    if (this.audioTimer) clearInterval(this.audioTimer);
    this.audioTimer = setInterval(this.handleAudioSlider, 1000);
  };

  handleAudioPause = () => {
    this.setState({ audioPlayerActive: false });
    clearInterval(this.audioTimer);
  };

  componentDidMount() {
    this.attachAudioListeners();
    this.audioFileRef.current.currentTime = 0;
  }

  componentWillUnmount() {
    this.pauseAudio();
    this.audioFileRef.current.removeEventListener("ended", this.handleAudioEnd);
    this.audioFileRef.current.removeEventListener("play", this.handleAudioPlay);
    this.audioFileRef.current.removeEventListener(
      "pause",
      this.handleAudioPause
    );
  }

  playAudio = async () => {
    if (this.audioFileRef.current) {
      this.props.handleAudioPlay(this.audioFileRef.current);
    }
    await this.audioFileRef.current.play();
    this.setState({ audioPlayerActive: true });
  };

  pauseAudio = () => {
    this.audioFileRef.current.pause();
    this.setState({ audioPlayerActive: false });
  };

  toggleAudio = () => {
    if (this.state.isAudioEnded) {
      this.audioFileRef.current.currentTime = 0;
      return this.setState({ isAudioEnded: false }, this.playAudio);
    } else {
      if (this.state.audioPlayerActive) {
        this.pauseAudio();
      } else {
        this.playAudio();
      }
    }
  };

  formatTime = (time) => {
    return `${Math.floor(time / 60)}:${Math.floor(time % 60)
      .toString()
      .padStart(2, "0")}`;
  };

  handleAudioSlider = () => {
    this.setState({
      currentTime: Math.round(this.audioFileRef.current.currentTime),
      currentSliderPosition:
        (this.audioFileRef.current.currentTime / this.state.audioDuration) *
        100,
    });
  };

  handleSliderChange = (e) => {
    let newTimeInSeconds = Math.round(
      this.state.audioDuration * (e.target.value / 100)
    );
    this.audioFileRef.current.currentTime = newTimeInSeconds;

    if (this.state.audioPlayerActive) {
      clearInterval(this.audioTimer);
      this.audioTimer = setInterval(this.handleAudioSlider, 1000);
    }

    this.setState({
      currentTime: newTimeInSeconds,
      currentSliderPosition: e.target.value,
    });

    if (e.target.value === 100) {
      this.setState({ isAudioEnded: true });
    } else {
      this.setState({ isAudioEnded: false });
    }
  };

  render() {
    return (
      <>
        <div className="gradingFeedbackAudioContainer">
          <h3 className="gradingFeedbackAudioHeader">{this.props.fileName}</h3>
          {!this.state.audioFileFetchOutstanding &&
          this.audioFileRef.current ? (
            <div className="gradingFeedbackAudioModuleWrapper">
              <button
                className="gradingFeedbackAudioModuleButton"
                onClick={() => this.toggleAudio()}
              >
                <FontAwesomeIcon
                  icon={
                    this.state.isAudioEnded
                      ? faRotateRight
                      : this.state.audioPlayerActive
                      ? faPause
                      : faPlay
                  }
                  className="gradingFeedbackAudioModuleIcon"
                />
              </button>
              <p className="gradingFeedbackAudioModuleTime">
                {this.formatTime(this.state.currentTime)}
              </p>
              <input
                type="range"
                className="gradingFeedbackAudioSlider"
                value={this.state.currentSliderPosition}
                onChange={this.handleSliderChange}
              />
              <p className="gradingFeedbackAudioModuleTime">
                {this.formatTime(this.state.audioDuration)}
              </p>
            </div>
          ) : (
            <div className="gradingFeedbackAudioModuleLoadingWrapper">
              <MDSpinner size={40} singleColor={this.props.primaryColor} />
            </div>
          )}
        </div>
      </>
    );
  }
}
